import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import { formatMoney } from 'lib/functions/utils';
import React from 'react';

interface DocumentsNotAppliedWarningDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  documentsCount: number;
  totalAmountAvailable: number;
}

const DocumentsNotAppliedWarningDialog: React.FC<
  DocumentsNotAppliedWarningDialogProps
> = ({ open, onClose, onConfirm, documentsCount, totalAmountAvailable }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="documents-not-applied-warning-title"
    >
      <DialogTitle id="documents-not-applied-warning-title">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <WarningAmberIcon color="warning" fontSize="medium" />
            <Typography variant="h6" fontWeight={600}>
              Advertencia: Documentos Disponibles No Aplicados
            </Typography>
          </Stack>
          <Typography variant="caption" color="text.secondary">
            Existen documentos que podrían aplicarse antes de crear la
            devolución
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            p: 2,
            bgcolor: 'warning.lighter',
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'warning.light',
            mb: 2,
          }}
        >
          <Stack spacing={1.5}>
            <Typography variant="body2" fontWeight={600} color="warning.dark">
              Resumen de documentos disponibles:
            </Typography>
            <Stack spacing={1}>
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="body2" color="text.secondary">
                  Cantidad de documentos disponibles:
                </Typography>
                <Typography variant="body2" fontWeight={600}>
                  {documentsCount}
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="body2" color="text.secondary">
                  Monto total disponible para aplicar:
                </Typography>
                <Typography variant="body2" fontWeight={600}>
                  {formatMoney(totalAmountAvailable)}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Box>

        <Box
          sx={{
            p: 2,
            bgcolor: 'info.lighter',
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'info.light',
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <InfoOutlinedIcon color="info" />
            <Typography variant="body2" color="text.secondary">
              ¿Deseas continuar de todas formas?
            </Typography>
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <CustomButton onClick={onClose} color="secondary">
          Cancelar
        </CustomButton>
        <CustomButton onClick={onConfirm} color="warning">
          Continuar de todas formas
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentsNotAppliedWarningDialog;
